export default __webpack_public_path__ + "static/media/arrow-left.34747575.svg";